var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.feed),function(message,index){return _c('div',{key:index},[(message.userCode === _vm.ldap && message.id !== '')?_c('message-own',_vm._b({},'message-own',message,false)):(message.id !== '')?_c('message-foreign',_vm._b({},'message-foreign',message,false)):_vm._e()],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51bc282e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/MessagesList.vue
// module id = null
// module chunks = 